export default __webpack_public_path__ + "static/media/checkbox-icon.5cda52a9.svg";